import { useState } from 'react';
import Buttons from '@components/Buttons';
import UserCirclePlus from '@components/Icons/UserCirclePlus';
import AddUserWorkflowCollaboratorModal from './AddUserWorkflowCollaboratorModal';
import s from '../UserWorkflowDetail.module.scss';

type Props = {
  userWorkflow: { id: string };
  onAddCollaborator: Parameters<typeof AddUserWorkflowCollaboratorModal>[0]['onSubmit'];
  myCollaborator: { canInviteCollaborators: boolean } | null;
};

const InviteCollaborators: React.FC<Props> = ({ userWorkflow, onAddCollaborator, myCollaborator }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // @todo - get new collaborator from modal to add to list above instead of reloading.
  const handleSubmit: Props['onAddCollaborator'] = async collaborator => {
    onAddCollaborator(collaborator);
    setIsModalOpen(false);
  };

  if (!myCollaborator || !myCollaborator.canInviteCollaborators) {
    return null;
  }

  return (
    <>
      {isModalOpen && userWorkflow.id && (
        <AddUserWorkflowCollaboratorModal userWorkflowId={userWorkflow.id} onClose={() => setIsModalOpen(false)} onSubmit={handleSubmit} />
      )}
      <Buttons
        isExtraSmall
        isPrimary
        className={s.invite}
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          setIsModalOpen(true);
        }}
      >
        <UserCirclePlus size={8} weight="fill" />
        Invite
      </Buttons>
    </>
  );
};

export default InviteCollaborators;
